import { GameRenderer } from './renderer.js';
import { GameController } from './gameController.js';
import { UIController } from './uiController.js';
import { useGameStore } from './gameStore.js';
import { SoundController } from './soundController.js';
import { AttractMode } from './attractMode.js';

// Initialize game
async function init() {
  // Get canvas
  const canvas = document.getElementById('game-canvas');
  
  // Create renderer
  const renderer = new GameRenderer(canvas);
  await renderer.init();
  
  // Create sound controller
  const soundController = new SoundController(useGameStore);
  soundController.init();
  
  // Create UI controller
  const uiController = new UIController(useGameStore, soundController);
  uiController.init();
  
  // Create game controller
  const gameController = new GameController(useGameStore, renderer);
  
  // Create attract mode manager
  const attractMode = new AttractMode(useGameStore, soundController, gameController);
  attractMode.startIdleMonitoring();
  
  // Set up pointer events on canvas
  canvas.addEventListener('pointerdown', (e) => {
    gameController.handlePointerDown(e);
  });
  
  // Handle visibility change (tab switch)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      // Cancel any active drag
      const state = useGameStore.getState();
      if (state.isDragging) {
        state.cancelDrag();
        if (state.dragStartCell) {
          renderer.snapBackToOrigin(state.dragStartCell);
        }
      }
    }
  });
  
  // Handle window resize / orientation change
  // Cancel active drag to avoid position desync (e.g. mid-merge rotation)
  window.addEventListener('resize', () => {
    const state = useGameStore.getState();
    // Cancel any pending or active drag so gem snaps back cleanly
    gameController.pendingDrag = null;
    if (state.isDragging) {
      state.cancelDrag();
      if (state.dragStartCell) {
        renderer.snapBackToOrigin(state.dragStartCell);
      }
    }
  });
  
  // Subscribe to store changes and update renderer
  useGameStore.subscribe((state, prevState) => {
    // Update grid when it changes
    if (state.grid !== prevState.grid || state.draggedGem !== prevState.draggedGem || state.cursedShards !== prevState.cursedShards) {
      renderer.updateGrid(state.grid, state.draggedGem, state.cursedShards || []);
    }
  });
  
  // Start game loop
  gameController.start();
  
  // Make controller globally available for debugging
  window.gameController = gameController;
  window.renderer = renderer;
  window.gameStore = useGameStore;
  
  console.log('Gemstone Gridlock initialized!');
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
